import { render, staticRenderFns } from "./rejas-filters.vue?vue&type=template&id=c0b99cc4"
import script from "./rejas-filters.vue?vue&type=script&lang=js"
export * from "./rejas-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports